/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/journal/2020-08-03_faith-family-friends.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/journal/2020-08-03_faith-family-friends.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/2020-08-03_faith-family-friends.mdx';

const metadata = {
  slug: "2020-08-03_faith-family-friends",
  title: "Faith, Family, Friends",
  author: "Christian Battaglia",
  description: "A life motto borrowed from Andy Stanley's \"Your Move\" podcast — when pro/con columns fail, filter life decisions through faith, family, and friends.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2020-08-03T00:00:00.000Z",
  
  readTime: "1 min read",
  tags: ["faith","family","friends","life motto","decision making","Andy Stanley","Northpoint","values"],
};

export const Route = createFileRoute('/blog/posts/2020-08-03_faith-family-friends')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/2020-08-03_faith-family-friends',
    image: '/og/blog/2020-08-03_faith-family-friends.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
